var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3",class:{
    'd-none':
      (_vm.item.displayOn && !_vm.display_none_check) ||
      (_vm.item.displayOn2 && !_vm.display_none_check2),
  }},[_c('Label',{attrs:{"item":_vm.item,"model_length":_vm.validation.$model.length}}),_c('ckeditor',{class:{ [_vm.item_key]: _vm.item_key },attrs:{"editor":_vm.editor,"config":_vm.editorConfig,"readonly":this.$route.params.categoryName == 'globalupdate'
        ? false
        : _vm.selectedItem?.additionalProp1 && _vm.selectedItem.additionalProp1.global
        ? true
        : false,"disabled":_vm.item.disabled
        ? true
        : this.$route.params.categoryName == 'globalupdate'
        ? false
        : _vm.selectedItem?.additionalProp1 && _vm.selectedItem.additionalProp1.global
        ? true
        : false},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),(_vm.submitted && _vm.validation.$error)?_c('div',{staticClass:"invalid-feedback"},[(!_vm.validation.required)?_c('span',[_vm._v("This value is required.")]):_vm._e()]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }